module.exports = __webpack_public_path__ + "assets/img/Logitech-Workspace-w540.9d5b5bd4.jpg";